export var LendiMemberType;
(function (LendiMemberType) {
    LendiMemberType["CUSTOMER"] = "customer";
    LendiMemberType["TEAM"] = "team";
    LendiMemberType["BOT"] = "bot";
})(LendiMemberType || (LendiMemberType = {}));
//# sourceMappingURL=LendiMember.js.map